import { render } from "./left_bar.vue?vue&type=template&id=43c33302"
import script from "./left_bar.vue?vue&type=script&lang=js"
export * from "./left_bar.vue?vue&type=script&lang=js"
script.render = render

export default script